/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNoDerivatives = createReactComponent("outline", "no-derivatives", "IconNoDerivatives", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10h6", "key": "svg-1" }], ["path", { "d": "M9 14h6", "key": "svg-2" }]]);

export { IconNoDerivatives as default };
//# sourceMappingURL=IconNoDerivatives.mjs.map
